import { Redirect, Route, useLocation } from 'react-router-dom';
import { Flow } from 'signup-constants/Flow';
import { Microapp } from 'signup-constants/Microapp';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { getFlowKey } from '../routing/getFlowKey';
import { getHistory } from '../routing/history';
import { jsx as _jsx } from "react/jsx-runtime";
const CmsFreeRoute = props => {
  const {
    hash,
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const queryParams = new URLSearchParams(getHistory().location.search);
  const flowKey = getFlowKey();
  if (flowKey === Flow.CmsFree && queryParams.get(SignupQueryKeys.Intent) === 'blogIdeasGenerator') {
    searchParams.delete(SignupQueryKeys.Intent);
    searchParams.set(Flow.Microapp, Microapp.BlogIdeasGenerator);
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/${Flow.Microapp}`,
        search: searchParams.toString(),
        hash
      }
    });
  }
  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};
export default CmsFreeRoute;